// import { ActionContext } from "vuex";
import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";
import {
	store,
	db,
	VIPCapability,
	VIPCompany,
	IVIPCapability,
	IVIPCompany,
} from "@/loader/public";
import { BvModal } from "bootstrap-vue";

@Module({
	name: "vip",
	store,
	dynamic: true,
	namespaced: true,
})
export class VIPModule extends VuexModule {
	public $bvModal!: BvModal;

	public animationEnterActive: string | null = null;
	public animationLeaveActive: string | null = null;
	public animationAppearActive: string | null = null;

	public certificatesSaved: boolean = false;
	public capabilitiesSaved: boolean = false;
	public projectsSaved: boolean = false;
	public companiesSaved: boolean = false;
	public contactsSaved: boolean = false;

	public capability: VIPCapability | null = null;
	public company: VIPCompany | null = null;

	@Mutation
	public init() {
		if (window.vip_data) {
			if (window.vip_data.ips) {
				db.ips.insertOrUpdateMany(window.vip_data.ips);
			}
			if (window.vip_data.productions) {
				db.productions.insertOrUpdateMany(window.vip_data.productions);
			}
		}
	}

	@Mutation
	public setModal(modal: BvModal) {
		this.$bvModal = modal;
	}

	@Mutation
	public createCompany(payload: IVIPCompany = {}) {
		this.company = db.companies.insert({ id: db.companies.list.nextNewId(), ...payload });
		this.$bvModal.show("company_modal");
	}

	@Mutation
	public showCompany(company: VIPCompany) {
		this.company = company;
		this.$bvModal.show("company_modal");
	}

	@Mutation
	public hideCompany() {
		this.company = null;
		this.$bvModal.hide("company_modal");
	}

	@Mutation
	public createCapability(payload: IVIPCapability = {}) {
		this.capability = db.capabilities.insert({ id: db.capabilities.list.nextNewId(), ...payload });
		this.$bvModal.show("capability_modal");
	}

	@Mutation
	public showCapability(capability: VIPCapability) {
		this.capability = capability;
		this.$bvModal.show("capability_modal");
	}

	@Mutation
	public hideCapability() {
		this.capability = null;
		this.$bvModal.hide("capability_modal");
	}
}

export const vip = getModule(VIPModule, store);
